"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spec = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const effect_1 = require("effect");
const openapi_1 = require("../../../../openapi");
const guard_1 = require("../guard");
const error_1 = require("../job/error");
const DeviceSchema = __importStar(require("../job/schema"));
const shared_1 = require("../shared");
const CommandJob = __importStar(require("./schema"));
exports.NAMESPACE = 'Culligan.Api.V1.Admin.Device.CommandJob.Spec';
const MAX_LIST_PAGE_SIZE = 1000;
const MAX_PROGRESS_PAGE_SIZE = 100;
const CommandJobPageResponse = openapi_1.Response.Success(CommandJob.CommandJobPage).annotations({
    description: 'Paginated command jobs',
});
const CommandJobItemResponse = openapi_1.Response.Success(CommandJob.CommandJobItem).annotations({
    description: 'A command job, or null when the id belongs to a job of a different kind',
});
const CommandJobProgressPageResponse = openapi_1.Response.Success(CommandJob.CommandJobProgressPage).annotations({
    description: 'Paginated command job target progress',
});
const CommandJobToggleResponse = openapi_1.Response.Success(CommandJob.CommandJobToggleResult).annotations({
    description: 'The job after the toggle/restart',
});
const CreatedJobResponse = openapi_1.Response.Success(DeviceSchema.CreatedJob).annotations({
    description: 'The created/updated job id',
});
// Query structs intentionally have no identifier (see shared.ts).
const ListQuery = effect_1.Schema.Struct({
    model: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }).annotations({
        description: 'Device model code',
    }),
    page: shared_1.page,
    pageSize: effect_1.Schema.optionalWith(shared_1.PositiveIntFromString.pipe(effect_1.Schema.lessThanOrEqualTo(MAX_LIST_PAGE_SIZE)), {
        exact: true,
    }).annotations({ description: 'Default 50.' }),
    size: effect_1.Schema.optionalWith(shared_1.PositiveIntFromString, { exact: true }).annotations({
        description: 'Validated but ignored on this endpoint; use pageSize.',
    }),
    orderBy: shared_1.orderBy,
    orderDir: shared_1.orderDir,
});
const ProgressQuery = effect_1.Schema.Struct({
    id: effect_1.Schema.NonEmptyString,
    page: shared_1.page,
    pageSize: effect_1.Schema.optionalWith(shared_1.PositiveIntFromString.pipe(effect_1.Schema.lessThanOrEqualTo(MAX_PROGRESS_PAGE_SIZE)), { exact: true }).annotations({ description: 'Default 50.' }),
    orderBy: shared_1.orderBy,
    orderDir: shared_1.orderDir,
});
const listCommandJobs = platform_1.HttpApiEndpoint.get('listCommandJobs') `/command/jobs/list`
    .setUrlParams(ListQuery)
    .addSuccess(CommandJobPageResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'List Command Jobs')
    .annotate(platform_1.OpenApi.Description, 'Lists command jobs, optionally filtered by model. Same pagination behavior as GET /ota/jobs/list.')
    .pipe(guard_1.withReadGuard, openapi_1.Error.withV1StandardErrors);
const getCommandJob = platform_1.HttpApiEndpoint.get('getCommandJob') `/command/job`
    .setUrlParams(effect_1.Schema.Struct({ id: effect_1.Schema.NonEmptyString }))
    .addSuccess(CommandJobItemResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotFound)
    .annotate(platform_1.OpenApi.Title, 'Get Command Job')
    .annotate(platform_1.OpenApi.Description, '404 when no job at all exists with this id; 200 { item: null } when the job exists but is a different kind (e.g. an OTA job).')
    .pipe(guard_1.withReadGuard, openapi_1.Error.withV1StandardErrors);
const getCommandJobProgress = platform_1.HttpApiEndpoint.get('getCommandJobProgress') `/command/job/progress`
    .setUrlParams(ProgressQuery)
    .addSuccess(CommandJobProgressPageResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotFound)
    .annotate(platform_1.OpenApi.Title, 'Get Command Job Progress')
    .pipe(guard_1.withReadGuard, openapi_1.Error.withV1StandardErrors);
const createCommandJob = platform_1.HttpApiEndpoint.post('createCommandJob') `/command/job`
    .setPayload(CommandJob.UpsertCommandJobPayload)
    .addSuccess(CreatedJobResponse, { status: 201 })
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'Create Command Job')
    .pipe(guard_1.withWriteGuard, openapi_1.Error.withV1StandardErrors);
const updateCommandJob = platform_1.HttpApiEndpoint.put('updateCommandJob') `/command/job`
    .setPayload(CommandJob.UpdateCommandJobPayload)
    .addSuccess(CreatedJobResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'Update Command Job')
    .annotate(platform_1.OpenApi.Description, '404 and CANNOT_EDIT_JOB do not actually trigger (a status-vs-statusCode bug): an unknown id creates a new job, and a job in any status is overwritten and reset to queued.')
    .pipe(guard_1.withWriteGuard, openapi_1.Error.withV1StandardErrors);
const toggleCommandJob = platform_1.HttpApiEndpoint.post('toggleCommandJob') `/command/job/toggle`
    .setPayload(DeviceSchema.JobIdPayload)
    .addSuccess(CommandJobToggleResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotFound)
    .addError(error_1.CannotToggleJob)
    .annotate(platform_1.OpenApi.Title, 'Toggle Command Job')
    .annotate(platform_1.OpenApi.Description, 'Pauses an active job or resumes a paused one. 422 CANNOT_TOGGLE_JOB for canceled, completed or failed jobs.')
    .pipe(guard_1.withWriteGuard, openapi_1.Error.withV1StandardErrors);
const restartCommandJob = platform_1.HttpApiEndpoint.post('restartCommandJob') `/command/job/restart`
    .setPayload(DeviceSchema.JobIdPayload)
    .addSuccess(CommandJobToggleResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotFound)
    .addError(error_1.CannotRestartJob)
    .addError(error_1.CannotScheduleJob)
    .annotate(platform_1.OpenApi.Title, 'Restart Command Job')
    .annotate(platform_1.OpenApi.Description, 'Allowed for coolDown, failed, waiting, queued, paused or canceled jobs (422 CANNOT_RESTART_JOB/CANNOT_SCHEDULE_JOB otherwise).')
    .pipe(guard_1.withWriteGuard, openapi_1.Error.withV1StandardErrors);
const cancelCommandJob = platform_1.HttpApiEndpoint.post('cancelCommandJob') `/command/job/cancel`
    .setPayload(DeviceSchema.JobIdPayload)
    .addSuccess(openapi_1.Response.EmptyData)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotFound)
    .addError(error_1.CannotCancelJob)
    .annotate(platform_1.OpenApi.Title, 'Cancel Command Job')
    .annotate(platform_1.OpenApi.Description, 'Stops the job and keeps it with its history: the job is switched off, set to canceled, and its pending schedule is cancelled. A step that is running stops before its next batch. 422 CANNOT_CANCEL_JOB for canceled, completed or failed jobs.')
    .pipe(guard_1.withWriteGuard, openapi_1.Error.withV1StandardErrors);
const deleteCommandJob = platform_1.HttpApiEndpoint.del('deleteCommandJob') `/command/job`
    .setUrlParams(effect_1.Schema.Struct({ id: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }) }))
    .setPayload(DeviceSchema.DeleteJobPayload)
    .addSuccess(openapi_1.Response.EmptyData)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotFound)
    .annotate(platform_1.OpenApi.Title, 'Delete Command Job')
    .annotate(platform_1.OpenApi.Description, 'Always deletes outright (never cancels). id may be supplied via query or body (at least one is required); the body id wins when both are present. To stop a job and keep its history, cancel it instead.')
    .pipe(guard_1.withWriteGuard, openapi_1.Error.withV1StandardErrors);
exports.Spec = platform_1.HttpApiGroup.make('v1.admin.device.command-job')
    .add(listCommandJobs)
    .add(getCommandJob)
    .add(getCommandJobProgress)
    .add(createCommandJob)
    .add(updateCommandJob)
    .add(toggleCommandJob)
    .add(restartCommandJob)
    .add(cancelCommandJob)
    .add(deleteCommandJob)
    .prefix('/admin/device')
    .annotate(platform_1.OpenApi.Title, 'Device Command Jobs')
    .annotate(platform_1.OpenApi.Description, 'Admin command job endpoints')
    .pipe(openapi_1.Audience.withAudiences(openapi_1.Audience.Audience.Admin));
//# sourceMappingURL=spec.js.map